import { sha256 } from 'js-sha256';

export const sha256Hash = (str: string): string => sha256(str);

/**
 * Retrieves the session ID directly from the local storage, which is set by the analytics-web-client.
 * It's a short-term solution that relies on two main assumptions:
 *  1. The local storage key for the session ID will not change.
 *  2. The session ID in the storage is kept up to date at all times.
 *     This is valid because getCurrentSessionId() from the analytics-web-client ensures
 *     a fresh value every time the session ID is retrieved (which is very frequent).
 */
export const getSessionIdFromLocalStorage = () => {
	// The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
	const LOCAL_STORAGE_KEY = 'awc.session.id';

	try {
		return localStorage.getItem(LOCAL_STORAGE_KEY) ?? undefined;
	} catch (error) {
		return undefined;
	}
};
